import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-model/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const photoContext = ["undeclared", "damaged", "verification"] as const;
export type PhotoContext = (typeof photoContext)[number];

export const uploadEvidencePhoto = {
  name: "uploadEvidencePhoto" as const,
  input: z
    .object({
      imageData: z
        .string()
        .describe("Base64 data URL string (data:image/...;base64,...)"),
      returnId: zExt.objectId().optional(),
      sessionId: processingSessionIdFormat.schema.optional(),
      sessionItemId: processingSessionItemIdFormat.schema.optional(),
      photoContext: z
        .enum(photoContext)
        .describe("The context in which the photo was taken"),
    })
    .refine(
      (input) =>
        (input.returnId === undefined) !== (input.sessionId === undefined),
      { message: "Provide exactly one of returnId or sessionId" },
    )
    .refine((input) => !input.returnId || input.sessionItemId, {
      message: "sessionItemId is required when uploading return evidence",
    }),
  output: z.object({
    url: z.string().describe("S3 URL of the uploaded photo"),
  }),
};
